import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const useEmptyStateStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: tokens.spacingVerticalXXL,
    gap: tokens.spacingVerticalM,
    textAlign: 'center',
    minHeight: '300px',
  },
  /**
   * Figma 2026 empty state: soft-tinted illustration block (`sectionIconBg`)
   * containing the icon, plus a navy primary CTA below. Opt-in via
   * `figmaVariant=true`.
   */
  containerFigma: {
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke1),
    borderRadius: '0.5rem',
  },
  iconBadgeFigma: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '4rem',
    height: '4rem',
    backgroundColor: tokens.colorBrandBackground2Hover,
    color: tokens.colorBrandForeground1,
    borderRadius: '999px',
    marginBottom: tokens.spacingVerticalS,
  },
  icon: {
    fontSize: fontScale.heading,
    color: tokens.colorNeutralForeground3,
  },
  iconFigma: {
    fontSize: fontScale.heading,
    color: 'inherit',
  },
  title: {
    fontSize: fontScale.subheading,
    color: tokens.colorNeutralForeground1,
  },
  description: {
    fontSize: fontScale.body,
    color: tokens.colorNeutralForeground2,
    maxWidth: '400px',
  },
});
